import { FC, useState } from 'react'

import { RedRed60, SequenceMenu } from '@sequencehq/core-components'

import { ArchiveProductModal } from 'Products/modals'

export const ArchiveProductMenuItem: FC<{
  productId: string
  productName: string
  onClose: () => void
  onSuccess: () => void
}> = ({ productId, productName, onClose, onSuccess }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        key="archive-product"
        uuid="archive-product"
        label="Archive product"
        data-testid={`products.${productId}.menuItem.archive`}
        style={{ color: RedRed60 }}
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <ArchiveProductModal
          productId={productId}
          productName={productName}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
